import React, { useEffect, useRef, useState } from 'react';
import { ObjectArray } from '../Page';
import { ButtonSquare } from '../../../components/design/buttons/Button';
import { Modal } from 'react-bootstrap';
import { getMetadata } from '../../../services/sim.service';
import { GoogleMap, Marker, StandaloneSearchBox } from '@react-google-maps/api';
import { checkEligibility, checkout, otpConfirm } from '../../../services/sim.service';
import { trackSignUp } from '../../../tools/tracking';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/design/buttons/Button';
import { loginAccount, verifyCode } from '../../../services/accounts.service';
import { REACT_APP_GOOGLE_MAPS_API_KEY } from '../../../../config';
import { useJsApiLoader } from '@react-google-maps/api';

const MAP_LIBRARIES: ("places")[] = ["places"];

// Parse Google geocoder address components into the checkout delivery fields
const parseAddressComponents = (
    components: google.maps.GeocoderAddressComponent[] = [],
    formatted: string = ''
) => {
    const get = (types: string[]) => {
        const comp = components.find(c => types.some(t => c.types.includes(t)));
        return comp ? comp.long_name : '';
    };
    const streetNumber = get(['street_number']);
    const route = get(['route']);
    const address = [streetNumber, route].filter(Boolean).join(' ') || formatted;
    const countryComp = components.find(c => c.types.includes('country'));
    return {
        delivery_address: address,
        delivery_city: get(['locality', 'administrative_area_level_2']),
        delivery_district: get(['sublocality', 'sublocality_level_1', 'neighborhood', 'administrative_area_level_3']),
        delivery_postalcode: get(['postal_code']),
        delivery_country: countryComp ? countryComp.short_name : '',
    };
};

const Check: React.FC<ObjectArray> = ({ onOptionSelect, t, i18n, objs }) => {
    // Error message component
    const ErrorMessage = (error: string | null) => {
        if (!error) return null;
        return (
            <div className="alert alert-danger mt-3" role="alert">
                {error}
            </div>
        );
    };
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [otp, setOtp] = useState<any>();
    const [identityError, setIdentitiyError] = useState<string>();
    const [identityNumberError, setIdentitiyNumberError] = useState<string>();
    const [hasLocationError, setHasLocationError] = useState<boolean>(false);
    const [identityNumber, setIdentitiyNumber] = useState<string>(
        objs?.identityNumber || ""
    );
    const [identity, setIdentitiy] = useState<any>(
        objs?.identity || null
    );
    const [identities, setIdentities] = useState<any[]>([]);
    const [searchQuery, setSearchQuery] = useState<string>(

    );
    const [showCountryModal, setShowCountryModal] = useState(false);
    const [showMapModal, setShowMapModal] = useState(false);
    const [location, setLocation] = useState<{ lat: number; lng: number, address: string } | null>(
        objs?.location || objs?.type == "esim" ? { lat: 0, lng: 0, address: "" } : null
    );
    const [locationError, setLocationError] = useState<string>();
    const [deliveryDetails, setDeliveryDetails] = useState<any>(objs?.deliveryDetails || null);
    const [searchBox, setSearchBox] = useState<google.maps.places.SearchBox | null>(null);
    const [mapCenter, setMapCenter] = useState<{ lat: number; lng: number }>(
        objs?.location ? { lat: objs.location.lat, lng: objs.location.lng } : { lat: 24.7136, lng: 46.6753 }
    );
    const [gettingLocation, setGettingLocation] = useState<boolean>(false);
    const [otp_type, setOtpType] = useState<string>("PhoneNumber");
    const [otp_method, setOtpMethod] = useState<string>("PhoneNumber");
    const [otp_state, setOtpState] = useState<string>("");
    const [agentId, setAgentId] = useState<string>(objs?.agentId || "");
    const [showAgentIdModal, setShowAgentIdModal] = useState(false);
    const [agentIdError, setAgentIdError] = useState<string>("");

    // const [data_checkout, setDataCheckout] = useState<any>();
    const mapContainerStyle = {
        width: '100%',
        height: '400px'
    };

    const [rest_obj, setRestObj] = useState<any>();
    useEffect(() => {
        setIdentitiyNumberError("");
        setIdentitiyError("");
        setLocationError("");
    }, [identityNumber, identity, location]);
    const onClick = async () => {
        if (!identityNumber) {
            setIdentitiyNumberError(t("local_sim.identity_check.errors.identity_number_required"));
            return;
        } else if (!identity) {
            setIdentitiyError(t("local_sim.identity_check.errors.identity_required"));
            return;
        } else if (!location && objs.type == "sim") {
            setLocationError(t("local_sim.identity_check.errors.location_required"));
            return;
        }
        const obj = {
            identity,
            identity_number: identityNumber,
            location: location ? {
                latitude: location.lat,
                longitude: location.lng
            } : null,
            agentId: agentId
        };

        const dateOfBirthValue = objs.dateOfBirth
            ? new Date(`${objs.dateOfBirth}T12:00:00Z`).toISOString()
            : "";

        const data_form = {
            name: objs.firstName,
            nationality: obj.identity?.tcc_Id ?? 0,
            idNumber: obj.identity_number,
            idType: identityNumber.startsWith('1') ? 1 : 2,
            contractType: (objs.plan.contractTypeId).toString(),
            customerContactNumber: objs.number,
            lng: obj.location?.longitude.toString(),
            lat: obj.location?.latitude.toString(),
            plan_id: objs.plan_id,
            dateOfBirth: dateOfBirthValue,
            countryInfo: {
                name: obj.identity?.nameEN || obj.identity?.nameAr || "",
                tcC_ID: obj.identity?.tcc_Id ? String(obj.identity.tcc_Id) : "",
                countryCode: obj.identity?.countryCode || "",
                alpha2Code: obj.identity?.alpha2Code || "",
                alpha3Code: obj.identity?.alpha3Code || "",
                isO3166Code: obj.identity?.isO3166Code || "",
            },
        }

        const checkoutDateOfBirth = objs.dateOfBirth
            ? new Date(`${objs.dateOfBirth}T12:00:00Z`).toISOString()
            : "";

        const simType = objs.type == "sim" ? 1 : 2;
        const referralCode = agentId || '';

        const data_checkout = {
            nationality: {
                id: obj.identity_number,
                idType: identityNumber.startsWith('1') ? "1" : "2",
                eligible: true,
                country_id: obj.identity.tcc_Id,
                country_name: obj.identity.nameEN
            },
            //only data plan and mnp == true send null
            number: objs.requiresNumberReservation ? {
                reservation_id: null,
                identifier: null
            } : {
                reservation_id: objs.reserveNumber ? objs.reserveNumber : null,
                identifier: objs.phone ? objs.phone : null
            },
            customer: {
                email: objs.email,
                email_verified: 'false',
                contact_number_verified: 'true',
                contact_number: objs.number,
                contact_number_encrypted: '',
                name: objs.firstName,
                visitorOTPType: "",
                countryCode: objs.selectedCode,
                dateOfBirth: checkoutDateOfBirth
            },
            delivery: {
                delivery_lat: location?.lat.toString(),
                delivery_lng: location?.lng.toString(),
                delivery_notes: '',
                delivery_country: deliveryDetails?.delivery_country || '',
                delivery_address: deliveryDetails?.delivery_address || location?.address || '',
                delivery_city: deliveryDetails?.delivery_city || '',
                delivery_district: deliveryDetails?.delivery_district || '',
                delivery_postalcode: deliveryDetails?.delivery_postalcode || ''
            },
            plan_id: objs.plan_id,
            sim_type: simType,
            numberOrderType: objs.numberOrderType || 0,
            mnpOperator: objs.mnpOperator ? (objs.mnpOperator).toString() : '',
            mnpNumber: objs.mnpNumber || '',
            referral_code: referralCode,
            // physical SIM ordered with a referral code must be delivered;
            // otherwise omit the field and let SIM MS decide
            ...(simType === 1 && referralCode ? { requiresDelivery: 2 } : {})
        };

        if (objs.bringNumber === true) {
            setError(null);
            setLoading(true);
            checkout(data_checkout, objs.providerId, i18n.language).then((res: any) => {
                onOptionSelect({ fees: res.returnData.fees }, false);
                setOtp(res.returnData.otp);
                setOtpState("otp");
                setOtpType(res.returnData.otp.otpFor);
                setOtpMethod(res.returnData.otp.otpFor);
                setError(null);
                setLoading(false);
                const rest_obj__ = {
                    ...objs,
                    otp: res.returnData.otp,
                    tygoOrderId: res.returnData.tygoOrderId,
                    checkoutId: res.returnData.checkoutId,
                    providerCheckoutId: res.returnData.checkoutId,
                    amount: res.returnData.fees.filter((item: any) => item.type === 4)[0].value,
                    agentId: agentId,
                    providerOrderId: res.returnData.providerOrderId,
                    fees: res.returnData.fees
                }
                setRestObj(rest_obj__);
            }).catch((err: any) => {
                console.log(err);
                const errorMsg = err.response?.data?.errorMessage || t('local_sim.errors.checkout_failed');
                setError(errorMsg);
                toast.error(errorMsg);
                setLoading(false);
            });
        } else {
            checkEligibility(data_form, objs.providerId).then((res: any) => {
                if (res.returnData.isEligible) {
                    setError(null);
                    setLoading(true);
                    checkout(data_checkout, objs.providerId, i18n.language).then((res: any) => {
                        onOptionSelect({ fees: res.returnData.fees }, false);
                        setOtp(res.returnData.otp);
                        setOtpState("otp");
                        setOtpType(res.returnData.otp.otpFor);
                        setOtpMethod(res.returnData.otp.otpFor);
                        setError(null);
                        setLoading(false);
                        const rest_obj__ = {
                            ...objs,
                            otp: res.returnData.otp,
                            tygoOrderId: res.returnData.tygoOrderId,
                            checkoutId: res.returnData.checkoutId,
                            providerCheckoutId: res.returnData.checkoutId,
                            amount: res.returnData.fees.filter((item: any) => item.type === 4)[0].value,
                            agentId: agentId,
                            providerOrderId: res.returnData.providerOrderId,
                            fees: res.returnData.fees
                        }
                        setRestObj(rest_obj__);
                    }).catch((err: any) => {
                        console.log(err);
                        const errorMsg = err.response?.data?.errorMessage || t('local_sim.errors.checkout_failed');
                        setError(errorMsg);
                        toast.error(errorMsg);
                        setLoading(false);
                    });
                }
                else {
                    const errorMsg = res.data?.returnData?.errorMessage || t('local_sim.errors.eligibility_check_failed');
                    setError(errorMsg);
                    toast.error(errorMsg);
                    setLoading(false);
                }
            }).catch((err: any) => {
                const errorMsg = err.response?.data?.errorMessage || t('local_sim.errors.general_error');
                setError(errorMsg);
                toast.error(errorMsg);
                setLoading(false);
            });
        }
    };



    useEffect(() => {
        const d = async () => {
            try {
                const response = await getMetadata(i18n.language);
                setIdentities(response?.data.returnData);
            } catch (error) {
                console.error('Error fetching metadata:', error);
            }
        };

        d();
    }, []);

    const filteredIdentities = identities.filter(identity =>
        i18n.language === "ar"
            ? identity.nameAr.includes(searchQuery || "")
            : identity.nameEN.toLowerCase().includes(searchQuery?.toLowerCase() || "")
    );
    const { isLoaded: isMapLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: MAP_LIBRARIES,
    });


    const reverseGeocode = (lat: number, lng: number) => {
        try {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                if (status === 'OK' && results && results.length > 0) {
                    const address = results[0].formatted_address;
                    setLocation({ lat, lng, address });
                    setDeliveryDetails(parseAddressComponents(results[0].address_components, address));
                } else {
                    console.error('Geocoder failed: ' + status);
                    setLocation({ lat, lng, address: `${lat.toFixed(5)}, ${lng.toFixed(5)}` });
                    setDeliveryDetails(null);
                }
            });
        } catch (_) { }
    };

    const handleMapClick = (event: google.maps.MapMouseEvent) => {
        if (event.latLng) {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            reverseGeocode(lat, lng);
        }
    };

    const handlePlacesChanged = () => {
        if (!searchBox) return;
        const places = searchBox.getPlaces();
        if (places && places.length > 0) {
            const place = places[0];
            const lat = place.geometry?.location?.lat() ?? 0;
            const lng = place.geometry?.location?.lng() ?? 0;
            const address = place.formatted_address || place.name || '';
            setLocation({ lat, lng, address });
            setMapCenter({ lat, lng });
            setDeliveryDetails(parseAddressComponents(place.address_components, address));
        }
    };

    // Web-only: use the browser geolocation API (no TWK bridge on web)
    const getUserCoordinates = (): Promise<{ lat: number; lng: number }> => {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) { reject(new Error('Geolocation not supported')); return; }
            navigator.geolocation.getCurrentPosition(
                (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
                (err) => reject(err),
                { enableHighAccuracy: true, timeout: 10000 }
            );
        });
    };

    const handleUseCurrentLocation = () => {
        setGettingLocation(true);
        getUserCoordinates()
            .then(({ lat, lng }) => {
                setMapCenter({ lat, lng });
                reverseGeocode(lat, lng);
                setGettingLocation(false);
            })
            .catch((err) => {
                console.error('Could not get location:', err);
                setGettingLocation(false);
                toast.error(t('local_sim.identity_check.location_fetch_failed') || 'Could not get your location');
            });
    };

    // if (!isLoaded) return <div>Loading...</div>;


    const handleIdentityNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // Only allow digits
        if (/^\d*$/.test(value)) {
            setIdentitiyNumber(value);
            // If ID starts with 1, automatically set nationality to Saudi Arabia
            if (value.startsWith('1')) {
                const saudiIdentity = identities.find(id => id.nameEN === 'Saudi Arabia');
                if (saudiIdentity) {
                    setIdentitiy(saudiIdentity);
                }
            }
        }
    };

    return (
        <div className="d-flex flex-column align-items-center justify-content-center gap-4 w-100">
            {!error && (loading ? (
                <h1 className="text-center">
                    {t("local_sim.check.title")}
                    {loading && <span className="loading-dots" style={{ animationDelay: '0s' }}></span>}
                    {loading && <span className="loading-dots" style={{ animationDelay: '0.2s' }}></span>}
                    {loading && <span className="loading-dots" style={{ animationDelay: '0.4s' }}></span>}
                </h1>
            ) : (
                <div className='w-100'>
                    <div className="form-group">
                        <label htmlFor="">{t("local_sim.identity_check.identity_number")}</label>
                        <div className='input_bg d-flex gap-3 align-items-center mt-2' style={{ padding: "10px" }}>
                            <input
                                type="text"
                                className={`form-control form-control-lg${identityNumberError ? " is-invalid" : ""}`}
                                style={{ fontSize: '1.25rem' }}
                                value={identityNumber}
                                onChange={handleIdentityNumberChange}
                                maxLength={10}
                            />
                        </div>
                        {identityNumberError && <p className="text-danger">{identityNumberError}</p>}
                    </div>

                    <div className="form-group" onClick={() => setShowCountryModal(true)} style={{ cursor: 'pointer' }}>
                        <label htmlFor="">{t("local_sim.identity_check.identity")}</label>
                        <div className='input_bg d-flex gap-3 align-items-center p-4 mt-2' style={{ padding: "10px" }}>
                            <div >
                                {identity ? (
                                    <div className="d-flex align-items-center gap-3">
                                        <img
                                            src={identity.flagImageUrl}
                                            alt={identity.nameEN}
                                            style={{ width: "30px", marginRight: "10px" }}
                                        />
                                        <span>{i18n.language === "ar" ? identity.nameAr : identity.nameEN}</span>
                                    </div>
                                ) : (
                                    <span>{t("local_sim.identity_check.select_identity")}</span>
                                )}
                            </div>
                        </div>
                        {identityError && <p className="text-danger">{identityError}</p>}
                    </div>

                    {
                        objs.type === "sim" && (
                            <div className="form-group" onClick={() => setShowMapModal(true)} style={{ cursor: 'pointer' }}>
                                <label htmlFor="">{t("local_sim.identity_check.location")}</label>
                                <div className='input_bg d-flex gap-3 align-items-center p-4 mt-2' style={{ padding: "10px" }}>
                                    <div >
                                        {location ? (
                                            <div className="d-flex align-items-center gap-3">
                                                <img
                                                    src="https://maps.google.com/mapfiles/ms/icons/red-dot.png"
                                                    alt="Location"
                                                    style={{ width: "30px", marginRight: "10px" }}
                                                />
                                                <span>{location.address}</span>
                                            </div>
                                        ) : (
                                            <span>{t("local_sim.identity_check.select_location")}</span>
                                        )}
                                    </div>
                                </div>
                                {locationError && <p className="text-danger">{locationError}</p>}
                            </div>
                        )
                    }
                    <div className="mt-4 d-flex align-items-center gap-2">
                        <ButtonSquare
                            inner={
                                <div className='mx-5'>{t("local_sim.identity_check.button")}</div>
                            }
                            color="primary px-5"
                            isrounded={true}
                            onClick={onClick}
                        />
                        <span
                            style={{ cursor: "pointer", textDecoration: "underline", color: "#007bff" }}
                            onClick={() => setShowAgentIdModal(true)}
                        >
                            {t("local_sim.identity_check.add_agent_id") || "Add Agent Id (optional)"}
                        </span>
                    </div>
                </div>
            ))}

            {error && <p className="text-danger">{error}</p>}
            <Modal show={showAgentIdModal} onHide={() => setShowAgentIdModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("local_sim.identity_check.agent_id") || "Agent Id (optional)"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <input
                        type="text"
                        className={`form-control${agentIdError ? " is-invalid" : ""}`}
                        value={agentId}
                        onChange={e => setAgentId(e.target.value)}
                        onBlur={e => {
                            const value = e.target.value;
                            // Allow: xxx_12345, xxx-12345, xxxx-12345 (upper/lowercase)
                            const regex = /^(?:[a-zA-Z]{3}_[0-9]+|[a-zA-Z]{3,4}-[0-9]+)$/;
                            if (value === "" || regex.test(value)) {
                                setAgentIdError("");
                            } else {
                                setAgentIdError(t("local_sim.identity_check.agent_id_error") || "Allowed formats: xxx_12345, xxx-12345, xxxx-12345.");
                            }
                        }}
                        placeholder={t("local_sim.identity_check.agent_id_placeholder") || "Enter Agent Id (optional)"}
                    />
                    {agentIdError && <div className="invalid-feedback d-block">{agentIdError}</div>}
                    <small className='mt-2 d-block'>{t("local_sim.identity_check.agent_id_help") || "If you have an agent ID, please enter it here."}</small>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        inner={t("local_sim.identity_check.save") || "Save"}
                        color="primary"
                        isfullWidth={false}
                        onClick={() => {
                            if (!agentIdError) {
                                setShowAgentIdModal(false);
                            }
                        }}
                        size='md'
                        isDisabled={!!agentIdError}
                    />
                </Modal.Footer>
            </Modal>
            <Modal show={showCountryModal} onHide={() => setShowCountryModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("local_sim.identity_check.select_identity")}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}>
                    <input
                        type="text"
                        className="form-control mb-3"
                        placeholder={t("local_sim.identity_check.search_placeholder")}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    {filteredIdentities.map((identity) => (
                        <div
                            key={identity.id}
                            className="country-option d-flex gap-3 p-3 align-items-center"
                            onClick={() => {
                                setIdentitiy(identity);
                                setShowCountryModal(false);
                            }}
                            style={{ cursor: "pointer" }}
                        >
                            <img
                                src={identity.flagImageUrl}
                                alt={identity.nameEN}
                                style={{ width: "30px" }}
                            />
                            <span>{i18n.language === "ar" ? identity.nameAr : identity.nameEN}</span>
                            {identity.id === identity && <span className="ml-2">(Selected)</span>}
                        </div>
                    ))}
                </Modal.Body>
            </Modal>

            <Modal show={showMapModal} onHide={() => setShowMapModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{t("local_sim.identity_check.select_location")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!isMapLoaded ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
                            <span className="spinner-border" role="status" />
                        </div>
                    ) : (
                        <>
                            <div className="mb-2 d-flex flex-column gap-2">
                                <StandaloneSearchBox onLoad={setSearchBox} onPlacesChanged={handlePlacesChanged}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder={t("local_sim.identity_check.search_location_placeholder") || t("local_sim.identity_check.search_placeholder")}
                                    />
                                </StandaloneSearchBox>
                                <button
                                    className="btn btn-outline-secondary w-100"
                                    onClick={handleUseCurrentLocation}
                                    disabled={gettingLocation}
                                    type="button"
                                >
                                    {gettingLocation
                                        ? <span className="spinner-border spinner-border-sm" role="status" />
                                        : <span>&#x2316; {t("local_sim.identity_check.use_current_location") || "Use current location"}</span>
                                    }
                                </button>
                            </div>
                            <GoogleMap
                                mapContainerStyle={mapContainerStyle}
                                center={mapCenter}
                                zoom={location ? 14 : 6}
                                onClick={handleMapClick}
                                options={{ streetViewControl: false }}
                            >
                                {location && (
                                    <Marker
                                        position={location}
                                    />
                                )}
                            </GoogleMap>
                            {location?.address && (
                                <p className="text-secondary small mt-2 mb-0">{location.address}</p>
                            )}
                            <div className="mt-3 d-flex flex-column align-items-center">
                                <ButtonSquare
                                    inner={
                                        <div className='mx-5'>{t("local_sim.identity_check.confirm_location")}</div>
                                    }
                                    color="primary px-5"
                                    isrounded={true}
                                    onClick={() => {
                                        if (!location || !location.lat || !location.lng) {
                                            setHasLocationError(true);
                                            return;
                                        }
                                        setHasLocationError(false);
                                        setShowMapModal(false);
                                    }}
                                />
                                {hasLocationError && (
                                    <div className="text-danger mt-2">
                                        {t("local_sim.identity_check.select_location_error")}
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={otp_state === "otp"} onHide={() => setOtpState("")} className="modal_store_info" style={
                {
                    direction: i18n.language === "ar" ? "rtl" : "ltr"
                }
            }>
                <Modal.Header className="order-header" closeButton style={{
                    border: "none",
                    padding: "0",
                    width: "100%"
                }}>
                    <Modal.Title>{t('store.otp.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <OtpForm otp_obj={otp} providerId={objs.providerId} objs={objs} rest_obj={rest_obj} onOptionSelect={onOptionSelect} />
                </Modal.Body>
            </Modal>
            <style>{`
                .loading-dots {
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    margin: 0 2px;
                    background-color: black;
                    border-radius: 50%;
                    animation: bounce 1s infinite;
                }

                @keyframes bounce {
                    0%, 100% {
                        transform: translateY(0);
                    }
                    50% {
                        transform: translateY(-10px);
                    }
                }
            `}</style>
        </div>
    );
};

const OtpForm = ({ otp_obj, objs, providerId, rest_obj, onOptionSelect }: { otp_obj: any, objs: any, providerId: number, rest_obj: any, onOptionSelect: any }) => {
    const { t } = useTranslation();
    const [error, setError] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [otp, setOtp] = useState<string>("");
    // const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
    const [counter, setCounter] = useState<number>(60);

    const navigate = useNavigate();

    const handleOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // Only allow digits and limit to 6 characters
        if (/^\d{0,6}$/.test(value)) {
            setOtp(value);
            setError("");

            // If we have 4 or more digits, verify automatically
            if (value.length >= 6) {
                verify(value);
            }
        }
    };

    const verify = async (otpValue: string) => {
        setLoading(true);
        try {
            const res = await otpConfirm({ id: otp_obj.id, code: otpValue, plan_id: objs.plan_id }, providerId);
            if (res === false) {
                setError("Invalid OTP");
            } else {
                // The only point in the funnel where email and phone are both
                // known and verified. Hashed here and stashed, because the
                // purchase event fires after the gateway redirect, by which
                // time this component's state is gone.
                await trackSignUp({
                    email: objs?.email,
                    countryCode: objs?.selectedCode,
                    phone: objs?.number,
                    method: "mobile_otp",
                });
                onOptionSelect(rest_obj);
            }
        } catch (err: any) {
            setError(err.response.data.errorMessage);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCounter(prev => (prev === 0 ? 60 : prev - 1));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    // Determine which phone number to display based on numberOrderType
    const getPhoneNumberToDisplay = () => {
        if (objs.numberOrderType === 1) { // MNP Order
            return objs.mnpNumber || objs.number;
        } else { // Normal Order
            return objs.number;
        }
    };

    return (
        <div className="card_form">
            <div className="form-group">
                <p>{t("store.otp.info")} {getPhoneNumberToDisplay()}</p>
                <div className="my-3">
                    <input
                        type="tel"
                        className={`form-control form-control-lg ${error ? "is-invalid" : ""}`}
                        style={{
                            textAlign: 'center',
                            letterSpacing: '0.5em',
                            fontSize: '1.5em'
                        }}
                        placeholder=""
                        maxLength={6}
                        value={otp}
                        onChange={handleOtpChange}
                    />
                </div>
            </div>
            {error && (
                <div className="alert alert-danger mt-2 mb-3 gap-2 d-flex align-items-center" role="alert">
                    <i className="fas fa-exclamation-circle me-2"></i>
                    {error}
                </div>
            )}
            <Button
                inner={t("store.otp.submit")}
                color="primary"
                isfullWidth
                onClick={() => verify(otp)}
                isLoading={loading}
                isDisabled={otp.length < 4}
            />
        </div>
    );
}
export default Check;
